<template>
    <div>
        <div class="title">{{ title || '申请人信息' }}</div>
        <Form :model="form" :label-width="110" class="mt15" :rules="formRules" ref="form">
            <FormItem label="投保人名称：" class="w600" prop="companyName">
                <Input @on-blur="changeName" v-model="form.companyName" placeholder="请输入投保人名称" :maxlength="50">
                </Input>
            </FormItem>
            <FormItem label="投保人组织机构代码：" class="w600" prop="idNumber">
                <Input @on-blur="change" v-model="form.idNumber" placeholder="请输入投保人组织机构代码" :maxlength="18"></Input>
            </FormItem>
            <FormItem label="电话：" class="w600" prop="contactsPhone">
                <Input v-model="form.contactsPhone" placeholder="请输入电话"></Input>
            </FormItem>
            <FormItem label="被保险人名称：" class="w600" prop="insName">
                <Input v-model="form.insName" placeholder="请输入被保险人名称" @on-blur="change" :maxlength="150"></Input>
            </FormItem>
            <FormItem label="被保人通讯地址：" class="w600" prop="areaCode">
                <Area v-model="form.areaCode" placeholder="请选择省市区" @get-city-str="areaChange" style="width:100%" />
            </FormItem>
            <FormItem label="被保人详细地址：" class="w600" prop="insDEtAdd">
                <Input v-model="form.insDEtAdd" placeholder="请输入被保人详细地址" :maxlength="20"></Input>
            </FormItem>
            <FormItem label="邮编" class="w600" prop="insEmail">
                <Input v-model="form.insEmail" placeholder="请输入邮编" :maxlength="120"></Input>
            </FormItem>
            <FormItem label="项目名称：" class="w600" prop="projectName">
                <Input v-model="form.projectName" placeholder="请输入建筑工程项目名称" :maxlength="40"></Input>
            </FormItem>
            <FormItem label="项目合同地址：" class="w600" prop="projectAddress">
                <Input v-model="form.projectAddress" placeholder="请输入建筑工程项目合同地址" :maxlength="40"></Input>
            </FormItem>
            <FormItem label="工程造价：" class="w600" prop="projectCost">
                <Input v-model="form.projectCost" @on-blur="changeprojectCost" placeholder="请输入工程造价" :maxlength="18"
                    type="number"></Input>
            </FormItem>
            <FormItem label="计费方式：" prop="chargeMode" style="position: relative;" class="w600">
                <Input v-model="str" placeholder="请输入计费方式" :maxlength="200" :disabled="true"></Input>
                <!-- <span class="errorMsg">按照合同上的开工和竣工日填写，如果合同中没体现开工竣工日的，按照合同中的工期，从生效日起倒推截止日即可</span> -->
            </FormItem>
            <FormItem label="项目合同期限：" prop="proTime" style="position: relative;" class="w600 proTime">
                <daterange @on-change="val => { setDateRange(val, 'proTime') }" is-fulltime placeholder="请选择起保日期"
                    v-model="form.proTime" :isShowOption="true">
                </daterange>
                <span class="errorMsg">按照合同上的开工和竣工日填写，如果合同中没体现开工竣工日的，按照合同中的工期，从生效日起倒推截止日即可</span>
            </FormItem>
            <FormItem label="营业执照" class="w600" prop="businessLicenseUrl">
                <div v-for="(item, index) in uploadListLicenseArr" :key="index">
                    <div class="upItem">
                        <span class="upName">{{ item.name }}</span>
                        <Icon type="md-close" @click.native="handleRemoveL(item, index)" class="upClose" />
                    </div>
                </div>
                <UploadFileImg @on-success="val => uploadSuccess(val, 'businessLicenseUrl')"
                    :accept="['image', 'word', 'pdf', 'excel']" :onlyFile="true" style="width:100px">
                    <div class="upload-img-main" v-if="!form.uploadListLicense">
                        <Icon type="ios-camera" size="20"></Icon>
                        <p>点击上传</p>
                    </div>
                </UploadFileImg>
                <span class="upMsg">如需多选，请在选择时使用【CTRL+鼠标左键】进行选择多个文件</span>
            </FormItem>
            <FormItem label="工程合同" class="w600" prop="projectContract">
                <div v-for="(item, index) in uploadList" :key="index">
                    <div class="upItem">
                        <span class="upName">{{ item.name }}</span>
                        <Icon type="md-close" @click.native="handleRemove(item, index)" class="upClose" />
                    </div>
                </div>
                <UploadFileImg @on-success="val => uploadSuccessFile(val, 'projectContract')"
                    :accept="['image', 'word', 'pdf', 'excel']" :onlyFile="true" style="width:100px">
                    <div class="upload-img-main" v-if="!form.projectContract">
                        <Icon type="ios-camera" size="20"></Icon>
                        <p>点击上传</p>
                    </div>
                </UploadFileImg>
                <span class="upMsg">如需多选，请在选择时使用【CTRL+鼠标左键】进行选择多个文件</span>

            </FormItem>
            <FormItem label="保单发票邮寄地址：" prop="postAddress" class="w600">
                <Input v-model="form.postAddress" placeholder="请输入保单发票邮寄地址" :maxlength="200"></Input>
            </FormItem>
            <FormItem label="邮寄联系人：" prop="postContactName" class="w600">
                <Input v-model="form.postContactName" placeholder="请输入邮寄联系人" :maxlength="200"></Input>
            </FormItem>
            <FormItem label="邮寄联系人电话：" prop="postContactPhone" class="w600">
                <Input v-model="form.postContactPhone" placeholder="请输入邮寄联系人电话" :maxlength="200"></Input>
            </FormItem>
        </Form>
    </div>
</template>
<script>
import Area from '@/pages/haierProduct/components/common/Area'
import UploadFileImg from './uploadFile'
import daterange from '@/components/common/daterange'
import { gsIndustryType, gsCompany } from '@/common/dictionary'
export default {
    components: { Area, UploadFileImg, daterange },
    props: {
        info: Object,
        title: String,
        formInfo: Object,
    },

    data() {
        const validateLicens = (rule, value, callback) => {
            if (this.form.businessLicenseUrl.length == 0) {
                console.log(111, this.form.businessLicenseUrl.length == 0)
                return callback(new Error('请上传营业执照'));
            } else {
                callback();
            }
        }
        const validatePro = (rule, value, callback) => {
            if (this.form.projectContract.length == 0) {
                return callback(new Error('请上传工程合同'));
            } else {
                callback();
            }
        }
        const validateproTime = (rule, value, callback) => {
            if (this.form.proTime.length == 0) {
                return callback(new Error('建筑工程项目合同期限必填'));
            } else {
                callback();
            }
        }
        const validatePhone = (rule, value, callback) => {
            const mobileReg = /^(([1][3,4,5,7,8]\d{9})|([0]\d{10,11})|(\d{7,8})|(\d{4}|\d{3})-(\d{7,8}))$/
            const phoneReg = /^\d{4}-\d{8}|\d{4}-\d{7}$/
            if (!value || value === "") { callback(new Error("请输入联系方式")); }
            else if (value.length === 11) {
                if (!mobileReg.test(value)) {
                    callback(new Error("请输入正确的手机号码或者固话号码（固话格式：区号-号码）"))
                } else {
                    callback();
                }
            }
            else if (value.length === 12 || value.length === 13) {
                if (!phoneReg.test(value)) {
                    callback(new Error("请输入正确的手机号码或者固话号码（固话格式：区号-号码1）"))
                } else {
                    callback();
                }
            } else {
                callback(new Error("请输入正确的手机号码或者固话号码（固话格式：区号-号码）"))
            }
        }
        return {
            loading: false,
            acceptimage: 'image',
            defaultList: [],
            uploadListLicense: [],
            uploadList: [],
            str: '按工程造价',
            gsIndustryType: gsIndustryType,
            gsCompany: gsCompany,
            form: {
                chargeMode: '按工程造价',
                idUrl: '',
                businessLicenseUrl: '',
                projectContract: '',
                proTime: '',
                projectDateEnd: ''
            },
            uploadListLicenseArr: [],
            formRules: {
                companyName: [{ required: true, message: '投保人姓名必填', trigger: 'blur', pattern: this.rules.chinaName }],
                idNumber: [{ required: true, message: '投保人组织机构代码必填', trigger: 'blur' }],
                contactsPhone: [{ required: true, trigger: 'blur', validator: validatePhone, }],
                insName: [{ required: true, message: '被保人姓名必填', trigger: 'blur', pattern: this.rules.chinaName }],
                areaCode: [{ required: true, message: '通讯地址必填', trigger: 'change' }],
                insDEtAdd: [{ required: true, message: '被保人详细地址必填', trigger: 'blur' }],
                // contactsPhone: [{ required: true, message: '联系电话必填', trigger: 'blur', pattern: this.rules.tel }],
                insEmail: [{ required: true, message: '邮编必填', trigger: 'blur' }],
                projectName: [{ required: true, message: '建筑工程项目名称必填', trigger: 'blur' }],
                projectAddress: [{ required: true, message: '建筑工程项目合同地址必填', trigger: 'blur' }],
                projectCost: [{ required: true, message: '工程造价必填', trigger: 'blur' }],
                proTime: [{ required: true, trigger: 'change', validator: validateproTime, }],
                postAddress: [{ required: true, message: '保单发票邮寄地址必填', trigger: 'blur' }],
                postContactName: [{ required: true, message: '邮寄联系人必填', trigger: 'blur' }],
                postContactPhone: [{ required: true, message: '邮寄联系人电话必填', trigger: 'blur', pattern: this.rules.tel }],
                businessLicenseUrl: [{ required: true, validator: validateLicens, trigger: 'change', }],
                projectContract: [{ required: true, validator: validatePro, trigger: 'change', }],
            }
        }
    },
    mounted() {
        // this.uploadList = this.$refs.upload.fileList;
    },
    watch: {
        formInfo(val) {
            this.setInfo(val)
        }
    },
    methods: {
        setInfo(obj) {
            this.$set(this.form, 'companyName', obj.applicantName)
            this.$set(this.form, 'idNumber', obj.applicantList[0].idNumber)
            this.$set(this.form, 'contactsPhone', obj.insuredList[0].contactPhone)
            this.$set(this.form, 'insName', obj.insuredList[0].subjectName)
            this.$set(this.form, 'areaCode', obj.insuredList[0].areaCode)
            this.$set(this.form, 'insEmail', obj.insuredList[0].zipCode)
            this.$set(this.form, 'insDEtAdd', obj.insuredList[0].fullAddress)
            this.$set(this.form, 'projectName', obj.extraInfo.projectName)
            this.$set(this.form, 'projectAddress', obj.extraInfo.projectAddress)
            this.$set(this.form, 'projectCost', obj.extraInfo.projectCost)
            this.$set(this.form, 'chargeMode', obj.extraInfo.chargeMode)
            this.$set(this.form, 'proTime', [obj.extraInfo.projectDateStart, obj.extraInfo.projectDateEnd])
            this.$set(this.form, 'projectDateStart', obj.extraInfo.projectDateStart)
            this.$set(this.form, 'projectDateEnd', obj.extraInfo.projectDateEnd)
            this.uploadListLicense = obj.extraInfo.businessLicenseUrl.split(',')
            // this.uploadList = obj.extraInfo.projectContract.split(',')
            console.log( this.uploadListLicense,this.uploadList )
            this.form.businessLicenseUrl = obj.extraInfo.businessLicenseUrl
            this.form.projectContract = obj.extraInfo.projectContract
            this.$set(this.form, 'postAddress', obj.extraInfo.postAddress)
            this.$set(this.form, 'postContactName', obj.extraInfo.postContactName)
            this.$set(this.form, 'postContactPhone', obj.extraInfo.postContactPhone)

        },
        // 校验
        val() {
            this.form.chargeMode = '按工程造价'
            this.form.uploadListLicenseArr = this.uploadListLicenseArr
            this.form.uploadList = this.uploadList
            return new Promise((resolve, rejct) => {
                this.$refs.form.validate(valid => {
                    resolve(valid ? this.form : false)
                })
            })
        },
        // 回传给父组件，父组件传入开票组件，开票组件的公司名称和社会代码用此组件的值
        change() {
            this.$emit('on-change', this.form)
        },
        changeName() {
            this.$set(this.form, 'insName', this.form.companyName)
            this.$emit('on-change', this.form)
        },
        areaChange(val) {
            this.form.areaCode = val[2].value
            this.form.provinceCode = val[0].value
            this.form.provinceName = val[0].label
            this.form.cityCode = val[1].value
            this.form.cityName = val[1].label
            this.form.areaName = val[2].label
        },
        // 小写转大写
        resetUpperCaseValue(event) {
            if (event.target.value) {
                this.form.organizationCode = event.target.value.toUpperCase();
            }
        },
        setDateRange(val) {
            console.log(val)
            this.form.projectDateStart = val[0]
            this.form.projectDateEnd = val[1]
            this.form.proTime = val
            this.$emit('on-change', this.form)
        },
        handleView(name) {
            this.imgName = name;
            this.visible = true;
        },
        beforeUpload() {
            this.loading = true
        },
        // 上传回调方法
        uploadSuccess(val, key) {
            this.loading = false
            this.uploadListLicenseArr.push(val)
            this.form.businessLicenseUrl = ''
            this.uploadListLicenseArr.forEach(i => {
                this.form.businessLicenseUrl = i.url + ',' + this.form.businessLicenseUrl
            })
            this.$refs.form.validateField(key);
        },
        uploadSuccessFile(val, key) {
            this.uploadList.push(val)
            this.form.projectContract = ''
            this.uploadList.forEach(i => {
                this.form.projectContract = i.url + ',' + this.form.projectContract
            })
            this.$refs.form.validateField(key);
        },
        handleRemove(file, index) {
            this.uploadList.splice(index, 1)
            this.form.projectContract = ''
            this.uploadList.forEach(i => {
                this.form.projectContract = this.form.projectContract + ',' + i.url
            })
        },
        handleRemoveL(file, index) {
            this.uploadListLicenseArr.splice(index, 1)
            this.form.businessLicenseUrl = ''
            this.uploadListLicenseArr.forEach(i => {
                this.form.businessLicenseUrl = i.url + ',' + this.form.businessLicenseUrl
            })
            // this.form.businessLicenseUrl = this.uploadListLicense.join(", ");
        },
        handleBeforeUpload() {
            const check = this.uploadList.length < 5;
            if (!check) {
                this.$Notice.warning({
                    title: '最多上传五张'
                });
            }
            return check;
        },
        // 计算保费
        changeprojectCost() {
            this.$emit('on-changeCost', this.form.projectCost)
        }

    },

}
</script>
<style>
.proTime .ivu-picker-panel-sidebar {
    width: 104px
}
</style>
<style scoped lang="less">
.upItem {
    position: relative;
}

.upClose {
    width: 20px;
    position: absolute;
    top: 27%;
    // transform: translateY(-50%);
    left: 60%;
    display: none;
}

.upItem:hover .upClose {
    display: block;
}

.upName {
    display: inline-block;
    width: 50%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.upload-img-main {
    padding: 10px 0;
}

.errorMsg {
    font-size: 12px;
    color: red;
    position: absolute;
    top: 30px;
    width: 800px;
    left: 0px;
}

.upMsg {
    font-size: 12px;
    color: red;
    position: absolute;
    width: 800px;
    left: 0px;
    bottom: -27px !important;
}

.imgMai {
    margin-right: 10px;
}

.demo-upload-list {
    display: inline-block;
    width: 60px;
    height: 60px;
    text-align: center;
    line-height: 60px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    box-shadow: 0 1px 1px rgba(0, 0, 0, .2);
    margin-right: 4px;
}

.demo-upload-list img {
    width: 100%;
    height: 100%;
}

.demo-upload-list-cover {
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, .6);
}

.demo-upload-list:hover .demo-upload-list-cover {
    display: block;
}

.demo-upload-list-cover i {
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 2px;
}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/customizedEmployerLiability/common/Applicant.vue